import React from 'react'
import useMediaQuery from '../../../utils/useMediaQuery'
import ModalPreGameCard from './modalPreGameCard'
import AppSlider from '../../atoms/appSlider/appSlider'

import pubertad from '../../../assets/images/games/personajes/pubertad.png'
import Button from '../../atoms/button/button'
import pushPreGameMetric from './pushMetric'
import images_modal from '../../../assets/images/games/modal/images'
import images_pad from '../../../assets/images/games/pad/images'
import { ReplicaImageMBTetris, ReplicaImagePCTetris, textCountry } from './replica-pregame'

const Title = ({ mobile = false }) => {
  return (
    <h2 className="f-modal-pre-game__card__title">
      ¡Bienvenida al {mobile ? <br /> : null}Planeta Pubertad!
    </h2>
  )
}
const BonusIntructions = ({ className = '' }) => {
  return (
    <p className={className}>
      <b>{textCountry.text6} estar muy pendiente,</b> porque cada vez que caiga un personaje
      de Nosotras, tendrás que buscar una ficha del mismo color para ubicarlo.{' '}
      <b>¡Es tu Bonus Track, {textCountry.text7} para duplicar tus puntos!</b>
      <br /> <br />
      <b>
        Si te sale la <span className="--accent">V</span> también será un Bonus
        Track especial que triplicará tus puntos.
      </b>
      <br /> <br />
      {/* <b>
        El nivel de dificultad del juego irá avanzando, ¡así que tienes que dar
        lo mejor de ti!
      </b> */}
    </p>
  )
}
const Controls = () => {
  return (
    <div className="f-modal-pre-game__controls --tetris">
      <br />
      <div className="f-modal-pre-game__controls__row">
        <img src={images_pad.pad_left} className="f-modal-pre-game__pad-icon" />
        <p>
          <b className="--accent">Tecla de flecha izquierda:</b> {textCountry.text4} la pieza
          a la izquierda
        </p>
      </div>
      <br />
      <div className="f-modal-pre-game__controls__row">
        <img src={images_pad.pad_right} className="f-modal-pre-game__pad-icon" />
        <p>
          <b className="--accent">Tecla de flecha derecha:</b> {textCountry.text4} la pieza a
          la derecha
        </p>
      </div>
      <br />
      <div className="f-modal-pre-game__controls__row">
        <img src={images_pad.pad_down} className="f-modal-pre-game__pad-icon" />
        <p>
          <b className="--accent">Tecla de flecha abajo:</b> {textCountry.text4} la pieza
          hacia abajo
        </p>
      </div>
      <br />
      <div className="f-modal-pre-game__controls__row">
        <img src={images_pad.pad_up} className="f-modal-pre-game__pad-icon" />
        <p>
          <b className="--accent">Tecla de flecha arriba:</b> {textCountry.text5} la pieza en
          el sentido de las agujas de reloj
        </p>
      </div>
    </div>
  )
}
const MobileCard = ({ onEnd, children }) => {
  return (
    <ModalPreGameCard onCancel={onEnd}>
      <div className="f-modal-pre-game__mobile-wrapper">
        <Title mobile={true} />
        <br />
        <p className="--center">{textCountry.text1}</p>
        <br />
        <div>{children}</div>
      </div>
    </ModalPreGameCard>
  )
}
const MobileVersion = ({ onEnd }) => {
  const handlerCallToAction = e => {
    console.log(e.target.innerText)
    pushPreGameMetric('tetris', 'click', e.target.innerText)
    onEnd()
  }
  return (
    <AppSlider settings={{ infinite: false }}>
      <MobileCard onEnd={onEnd}>
        <figure>
          <img src={images_modal.tetris_preview} />
        </figure>
        <br />
        <p className="--center">
          {textCountry.text2}
          los espacios para <br />
          formar líneas. Una vez creadas, <br />
          <b>¡desaparecerán!</b>
        </p>
      </MobileCard>

      <MobileCard onEnd={onEnd}>
        <br />
        <p className="--custom-tetris-p2">
          <b>
            {textCountry.text18}
          </b>
        </p>
        <Controls />
      </MobileCard>

      <MobileCard onEnd={onEnd}>
        <figure>
          <ReplicaImageMBTetris/>
        </figure>
        <br />
        <BonusIntructions className="--center" />

        <Button onClick={handlerCallToAction} title="¡Quiero jugar ya!">
          ¡Quiero jugar ya!
        </Button>
      </MobileCard>
    </AppSlider>
  )
}
const PcVersion = ({ onEnd }) => {
  const handlerCallToAction = e => {
    pushPreGameMetric('tetris', 'click', e.target.innerText)
    onEnd()
  }
  return (
    <AppSlider settings={{ infinite: false }}>
      <ModalPreGameCard onCancel={onEnd}>
        <div className="f-modal-pre-game__flex-wrapper">
          <figure>
            <img src={images_modal.tetris_preview} />
          </figure>
          <aside>
            <div>
              <Title />
            </div>
            <br />
            <br />
            <div className="f-modal-pre-game__flex-wrapper">
              <figure>
                <img src={pubertad} />
              </figure>
              <aside>
                <p>
                  <b>{textCountry.text1}</b>
                  <br />
                  <br />
                  {textCountry.text2} <br />
                  los espacios para formar líneas. Una vez creadas,{' '}
                  <b>¡desaparecerán!</b>
                  <br />
                  <br />
                  <b>
                    {textCountry.text3}
                    mover las piezas en el escenario:
                  </b>
                </p>
              </aside>
            </div>
            <Controls />
          </aside>
        </div>
      </ModalPreGameCard>

      <ModalPreGameCard onCancel={onEnd}>
        <div className="f-modal-pre-game__flex-wrapper">
          <aside>
            <ReplicaImagePCTetris/>
          </aside>
          <aside>
            <div>
              <Title />
              <p className="--center">{textCountry.text1}</p>
            </div>
            <br />

            <br />
            <div>
              <BonusIntructions />
            </div>

            <br />
            <div>
              <Button onClick={handlerCallToAction} title="¡Quiero jugar ya!">
                ¡Quiero jugar ya!
              </Button>
            </div>
          </aside>
        </div>
      </ModalPreGameCard>
    </AppSlider>
  )
}
const PreGameTetris = ({ onEnd }) => {
  const isMobile = useMediaQuery()
  return isMobile ? (
    <MobileVersion onEnd={onEnd} />
  ) : (
    <PcVersion onEnd={onEnd} />
  )
}

export default PreGameTetris
